<template>
  <div class="container">
    <div class="alert alert-success" v-if="messagesuccess">
      <h5 style="color: white; text-align: center; font-family: sans-serif">
        {{ messagesuccess }}
      </h5>
    </div>
    <LoadedComponent :loading="loading" />

    <div class="row" v-if="!loading">
      <div class="col-lg-9">
        <div class="row" v-if="publishAdv">
          <div class="col-lg-12">
            <div class="pt-4 pr-5">
              <AdvComponent :advertisings="advertisings" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="pt-4 pr-5">
              <h4 class="text-center">Casi Clinici</h4>
              <SwiperComponents :elements="clinicalCases" category="1" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="pt-4 pr-5">
              <h4 class="text-center">Meeting</h4>
              <SwiperComponents :elements="meeting" category="3" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="pt-4 pr-5">
              <h4 class="text-center">Biblioteca</h4>
              <SwiperComponents :elements="library" category="2" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-12">
            <div class="pt-4 pr-5">
              <h4 class="text-center">Presentazioni</h4>
              <SwiperComponents :elements="presentation" category="4" />
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="row">
          <aside class="col-lg-12 pt-4">
            <div class="widget widget-cats">
              <div class="row">
                <div class="col-md-3 text-md-left text-center">
                  <h3 class="widget-title">News</h3>
                </div>
                <div class="col-md-3">
                  <a href="#newsletter-create-modal" data-toggle="modal" v-if="create_newsletter">
                    <div class="d-md-none d-lg-none text-center font-weight-bold">
                      Aggiungi newsletter
                      <i class="icon-plus font-weight-bold" style="font-size: 15px"></i>
                    </div>
                    <div class="d-none d-lg-block d-md-block">
                      <i class="icon-plus font-weight-bold"></i>
                    </div>
                  </a>
                </div>
                <ul class="pb-2 m-2" style="overflow-y: auto; height: 500px">
                  <li v-for="(newsletter, index) in newsletters" :key="index" class="m-4 m-md-0 m-lg-0">
                    <a href="#modal-show-newsletter" class="btn-product btn-quickview"
                      style="padding-top: 0px; padding-bottom: 0px"></a>
                    <div v-html="newsletter.description"></div>

                    <span v-if="newsletter.deleted">
                      <button type="button" class="btn btn-link" data-toggle="modal" data-target="#confirm-delete"
                        @click="showConfirmationDelete(newsletter.id)">
                        <i class="las la-trash-alt default-color"></i>
                      </button>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </aside>

          <aside class="col-lg-12">
            <!-- <div class="widget widget-cats">
              <h3 class="widget-title">Calendario</h3>
             
              <FullCalendar :options="calendarOptions" />
            </div>-->
          </aside>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="confirm-delete" v-if="modaldeletenewsletter">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Conferma eliminazione</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-news">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <p>Sei sicuro di voler eliminare l'elemento?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-danger" @click="deleteElement">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="newsletter-create-modal" tabindex="-1" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document" id="modal-create-newsletter">
        <div class="modal-content">
          <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-new-news">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>

            <div class="form-box">
              <div class="form-tab">
                <ul class="nav nav-pills nav-fill" role="tablist">
                  <li class="nav-item">
                    <a class="nav-link" id="signin-tab" data-toggle="tab" href="#signin" role="tab"
                      aria-controls="signin" aria-selected="true">Nuova newsletter</a>
                  </li>
                </ul>
                <div class="tab-content" id="tab-content-5">
                  <div class="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
                    <form @submit.prevent="newsletterstore">
                      <div class="form-group">
                        <label for="singin-email">Messaggio</label>
                        <QuillEditor v-model:content="newsletterform.description" contentType="html" theme="snow" />
                      </div>

                      <div class="alert alert-danger" v-if="errors.description">
                        {{ errors.description[0] }}
                      </div>
                      <div class="form-footer">
                        <button type="submit" class="btn btn-outline-primary-2 btn-order btn-block">
                          <span class="btn-text">Invia</span>
                          <span class="btn-hover-text">Pubblica la newsletter</span>
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End .modal -->
  </div>
</template>

<script>
import httpauth from "@/services/httpauth.js";
import SwiperComponents from "@/components/SwiperComponents.vue";

import httpservices from "@/services/httpservices";

import LoadedComponent from "@/components/LoadedComponent.vue";
import { useAuth } from "@/stores/auth.js";
import AdvComponent from "@/components/AdvComponent.vue";
import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
export default {
  name: "HomePage",
  components: {
    SwiperComponents,
    LoadedComponent,
    AdvComponent,
    QuillEditor,
  },
  props: {},
  data() {
    return {
      clinicalCases: [],
      attributes: [],
      meeting: [],
      library: [],
      presentation: [],
      newsletters: [],
      forum: [],
      loading: true,
      publishAdv: false,
      advertisings: [],
      errors: {},
      newsletterform: {
        description: "",
      },
      create_newsletter: false,
      messagesuccess: "",
      newsletterid: 0,
      modalstorenewsletter: false,
      modaldeletenewsletter: false,
    };
  },
  mounted() {
    if (this.publishAdv)
    {
      this.adv();
    }

    httpauth
      .get("/dashboard")
      .then((response) => {
        var data = response.data;
        this.clinicalCases = data.clinicalCases;
        this.meeting = data.meetings;
        this.library = data.libraries;
        this.presentation = data.presetations;
        this.newsletters = data.newsletters;
        this.loading = false;
        // Gestisci l'array di oggetti come desiderato
      })
      .catch((error) => {
        console.log(error);
        const auth = useAuth();
        if (
          error.response.status == 401 &&
          error.response.data.message == "Unauthenticated."
        )
        {
          auth.clearToken();
          window.location.href = "/";
        }
      });
  },
  created() {
    httpservices
      .checkPermission(0, "newsletter", "create_newsletter")
      .then((response) => {
        this.create_newsletter = response.data.permission;
      });
  },
  methods: {
    async adv() {
      await httpauth
        .get("/advertising")
        .then((response) => {
          this.advertisings = response.data.data.content;
          console.log(this.advertisings);
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    dayClicked(day) {
      console.log(day);
    },
    async newsletterstore() {
      await httpauth
        .post("/newsletter/store", this.newsletterform)
        .then((response) => {
          document.getElementById("close-modal-new-news").click();
          this.newsletterform.description = "";
          this.messagesuccess = response.data.message;
          this.shownewsletter();
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    showConfirmationDelete(id) {
      this.modaldeletenewsletter = true;
      this.newsletterid = id;
    },
    async shownewsletter() {
      await httpauth
        .get("/newsletter")
        .then((response) => {
          this.newsletters = [];
          this.newsletters = response.data.data;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },
    async deleteElement() {
      if (this.newsletterid != 0)
      {
        await httpauth
          .get("/newsletter/delete/" + this.newsletterid, [
            {
              params: { id: this.newsletterid }, // Passa l'ID come oggetto nel campo 'data'
            },
          ])
          .then((response) => {
            document.getElementById("close-modal-delete-news").click();
            this.modaldeletenewsletter = false;
            this.messagesuccess = response.data.message;
            this.shownewsletter();
          })
          .catch((error) => {
            this.errors = error.response.data.errors;
          });
      } else
      {
        this.errors.message = "Non è stato inserito nessuna newsletter";
      }
    },
  },
};
</script>
